<template>
  <v-container>
      <ViewNewOrders />
  </v-container>
</template>

<script>
import ViewNewOrders from '@/components/ViewNewOrders'
import moment from 'moment'

export default {
  name: 'ViewTable',
  components: {
    ViewNewOrders
  }
}
</script>

<style scoped>

</style>
